module.exports = __webpack_public_path__ + "static/media/speaker3.9288af37.png";